var Reflux  = require('reflux'),
    axios = require('axios');

var isEqual = require('lodash/lang/isEqual');

var Actions               = require('advocate/challenges/actions');
var ExperiencesActions    = require('advocate/challenges/actions/experiences_actions');
var ExperiencesCollection = require('advocate/challenges/stores/experiences_collection');
var ChannelsActions       = require('advocate/challenges/actions/channels_actions');
var ChannelsCollection    = require('advocate/challenges/stores/channels_collection');

var client = axios.create({
  // axios timeout set this high as the /challenges/buckets/immediate endpoint
  // can take a significant amount of time to load on certain hubs
  timeout: 60000,
  headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
});


var ChallengeBrowserCollection = Reflux.createStore({
  listenables: Actions,

  init: function () {
    this.data = {
      challenges : [[]],
      unlockableChallenges : [[]],
      experiences : [],
      channels : [],
      hasMoreChallenges : false,
      hasMoreUnlockableChallenges : false,
      loadingChallenges : true,
      loadingUnlockableChallenges: false,
      errors : null,
      challengeStatusDescription : {
        challengeId : "",
        statusDescription : ""
      },
      challengeListLoaded : false,
      unlockableChallengesListLoaded: false
    };
    this.endpoint = "";
    this.filter = "";
    this.pageSize = 24;
    this.challengesLoaded = false;
    this.experiencesLoaded = false;
    this.channelsLoaded = false;

    ChannelsCollection.listen(this._onChannelsUpdate);
    ExperiencesCollection.listen(this._onExperiencesUpdate);
  },

  onSetPageSize : function(pageSize){
    this.pageSize = pageSize;
  },

  onSetChannelId: function (channelId) {
    this.channelId = channelId;
  },

  onSetCurrentChannel: function(channel) {
    this.currentChannel = channel
  },

  onFetchChannels: function () {
    ChannelsActions.fetchChannels();
  },

  _onChannelsUpdate: function (data) {
    var shouldTrigger = false;

    this.channelsLoaded = true;
    if (!this.data.challengeListLoaded && this.challengesLoaded) {
      this.data.challengeListLoaded = true;
      shouldTrigger = true;
    }

    if (this._channelsHaveChanged(data) && data.errors === null) {
      this.data.channels = data.channels;
      this.data.hideCounters = data.hideCounters;
      shouldTrigger = true;
    }

    if (shouldTrigger) {
      this.trigger({ ...this.data });
    }
  },

  _channelsHaveChanged: function (data) {
    return !isEqual(this.data.channels, data.channels);
  },

  onFetchExperiences : function(){
    ExperiencesActions.fetchExperiences();
  },

  _onExperiencesUpdate : function(data){
    var shouldTrigger = false;

    this.experiencesLoaded = true;
    if (!this.data.challengeListLoaded && this.challengesLoaded) {
      this.data.challengeListLoaded = true;
      shouldTrigger = true;
    }

    if(this._experiencesHaveChanged(data) && data.errors === null){
      this.data.experiences = data.experiences;
      this.data.hideCounters = data.hideCounters;
      shouldTrigger = true;
    }

    if (shouldTrigger) {
      this.trigger({...this.data});
    }
  },

  _experiencesHaveChanged : function(data){
    return !isEqual(this.data.experiences, data.experiences);
  },

  onLaterChallenge : function(challengeId, csrf_token){
    client.post("/challenges/" + challengeId + "/dismiss", '', { 'headers': { 'X-CSRF-Token': csrf_token } })
      .catch(function(error){
        console.error(error);
      });
  },

  onRetrieveChallengeStatusDescription: function(challengeId, status) {
    client.get("/challenges/" + challengeId + "/status_info/" + status)
      .then(function(response){
          this.data.challengeStatusDescription = {
            challengeId : challengeId,
            status: status,
            statusDescription : response.data.status_description
          };
          this.trigger(this.data);
        }.bind(this)
      ).catch(function(error) {
        console.error(error);
        this.data.challengeStatusDescription = "";
        this.trigger(this.data);
      }.bind(this));
  },

  onFetchAvailableChallenges : function(filter, sort, pageNumber) {
    this._onFetchChallenges(filter, "immediate", undefined, pageNumber, sort);
  },

  onFetchNewestChallenges : function(filter, sort, pageNumber) {
    this._onFetchChallenges(filter, "immediate", undefined, pageNumber, 'most_recent_published');
  },

  onFetchWaitingChallenges : function(filter, sort, pageNumber) {
    this._onFetchChallenges(filter, "waiting", undefined, pageNumber, sort);
  },

  onFetchLaterChallenges : function(filter, sort, pageNumber) {
    this._onFetchChallenges(filter, "dismissed", undefined, pageNumber, sort);
  },

  onFetchCompletedChallenges : function(filter, sort, pageNumber) {
    this._onFetchChallenges(filter, "completed", undefined, pageNumber, sort);
  },

  onFetchUnlockedChallenges : function(sort, unlockedChallengeIds) {
    this._onFetchChallenges(this.filter, "immediate", unlockedChallengeIds, 1, sort);
  },

  onFetchUnlockableChallenges: function(filter, sort, pageNumber) {
    filter = filter || "";
    pageNumber = pageNumber || 1;

    client.get(this._challengesURL(filter, 'unlockable', undefined, pageNumber, sort))
      .then(function(response){
          if (pageNumber === 1) this.data.unlockableChallenges = [[]];

          var challenges = mobile.android.filterKitkatChallenges(response.data.challenges);
          var challengeTypes = response.data.challenge_types;

          this.data.unlockableChallenges.push(challenges);
          this.data.hasMoreUnlockableChallenges = challenges.length >= this.pageSize
          this.data.loadingUnlockableChallenges = false;
          this.data.challengeTypes = challengeTypes;
          this.data.unlockableChallengesListLoaded = true;
          this.data.errors = null;

          this.trigger({...this.data});
        }.bind(this)
      ).catch(function(error) {
        console.error(error);
        this._failureResponse(error);
        this.data.unlockableChallengesListLoaded = true;

        this.trigger({...this.data});
      }.bind(this));
  },

  _onFetchChallenges: function (filter, endpoint, unlockedChallengeIds, pageNumber, sort){
    filter = filter || "";
    endpoint = endpoint || "immediate";
    pageNumber = pageNumber || 1;

    client.get(this._challengesURL(filter, endpoint, unlockedChallengeIds, pageNumber, sort))
      .then(function(response){
          this._successfulResponse(response, filter, endpoint, unlockedChallengeIds, pageNumber);
          this.challengesLoaded = true;
          if (!this.data.challengeListLoaded && this.experiencesLoaded) {
            this.data.challengeListLoaded = true;
          }
          if (!this.data.challengeListLoaded && this.channelsLoaded) {
            this.data.challengeListLoaded = true;
          }
          this.trigger({...this.data});
        }.bind(this)
      ).catch(function(error) {
        console.error(error);
        this._failureResponse(error);
        this.challengesLoaded = true;
        if (!this.data.challengeListLoaded && this.experiencesLoaded) {
          this.data.challengeListLoaded = true;
        }
        if (!this.data.challengeListLoaded && this.channelsLoaded) {
          this.data.challengeListLoaded = true;
        }
        this.trigger({...this.data});
      }.bind(this));
  },

  _successfulResponse : function(response, filter, endpoint, unlockedChallengeIds, pageNumber){
    this._handleEndpointChange(endpoint);
    this._handleFilterChange(filter);
    this._handlePageChange(pageNumber);
    this._updateData(response, unlockedChallengeIds);
    this.data.errors = null;
  },

  _failureResponse : function(errors){
    this.data.challenges = [[]];
    this.data.unlockableChallenges = [[]];
    this.data.loadingChallenges = false;
    this.data.loadingUnlockableChallenges = false;
    this.data.hasMoreChallenges = false;
    this.data.hasMoreUnlockableChallenges = false;
    this.data.errors = errors;
  },

  _challengesURL : function(filter, endpoint, unlockedChallengeIds, pageNumber, sort){
    return "/challenges/buckets/" + endpoint + "/" +
      filter +
      "?per_page=" + this.pageSize +
      "&channel_id=" + this.channelId +
      "&sort=" + sort +
      "&page=" + pageNumber +
      this._buildChallengIdsUrl(unlockedChallengeIds);
  },

  _buildChallengIdsUrl : function(unlockedChallengeIds){
    var urlChallengeIds = "";
    if(unlockedChallengeIds) {
      urlChallengeIds = "&id=" + unlockedChallengeIds.join(",");
    }
    return urlChallengeIds;
  },

  _handleEndpointChange : function(endpoint){
    if(this.endpoint !== endpoint){
      this.data.challenges = [[]];
      this.endpoint = endpoint;
    }
  },

  _handleFilterChange : function(filter){
    if(this.filter !== filter){
      this.data.challenges =  [[]];
      this.filter = filter;
    }
  },

  _handlePageChange : function(pageNumber){
    if (pageNumber === 1) {
      this.data.challenges = [[]];
    }
  },

  _updateData : function(response, unlockedChallengeIds){
    var challenges = mobile.android.filterKitkatChallenges(response.data.challenges);
    var challengeTypes = response.data.challenge_types;

    this.data.challenges.push(this._markUnlockedChallenges(challenges, unlockedChallengeIds));
    this.data.hasMoreChallenges = (challenges.length < this.pageSize) ? false : true;
    this.data.loadingChallenges = false;
    this.data.challengeTypes = challengeTypes;
  },

  _markUnlockedChallenges : function(challenges, unlockedChallengeIds){
    if(unlockedChallengeIds === undefined){
      return challenges;
    }

    for(var i = 0; i < challenges.length; i++){
      if(unlockedChallengeIds.indexOf(challenges[i].id) > -1){
        challenges[i].unlocked = true;
      }
    }

    return challenges;
  },
});

module.exports = ChallengeBrowserCollection;



// WEBPACK FOOTER //
// ./src/advocate/challenges/stores/challenge_browser_collection.js